import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67a5bf22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5 pb-5 bg-white" }
const _hoisted_2 = {
  key: 0,
  class: "p-3"
}
const _hoisted_3 = { class: "pb-2 border-bottom border-color-gray03 text-size-14 text-weight-500 text-primary-dark" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "p-3" }
const _hoisted_6 = { class: "pb-2 border-bottom border-color-gray03 text-size-14 text-weight-500 text-primary-dark" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_SimpleCheckbox = _resolveComponent("SimpleCheckbox")!
  const _component_ConfirmRoute = _resolveComponent("ConfirmRoute")!
  const _component_OrderFixedButton = _resolveComponent("OrderFixedButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      申込条件確認\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allConditions, (conditions, conditionName) => {
        return (_openBlock(), _createElementBlock("div", { key: conditionName }, [
          (conditions.items.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("h2", _hoisted_3, _toDisplayString(conditions.head), 1),
                _createTextVNode(),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conditions.items, (condition, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: _normalizeClass(["req-list-item", _ctx.abTest3401Class]),
                      onClick: ($event: any) => (_ctx.onClickListItemCheck(conditionName, index))
                    }, [
                      (_ctx.isAbTest3401TestGroup)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["req-list-item-text", { 'checked-text': condition.isChecked }])
                            }, _toDisplayString(condition.text), 3),
                            _createTextVNode(),
                            _createVNode(_component_SimpleCheckbox, {
                              checked: condition.isChecked,
                              label: "",
                              class: "req-item-indicator",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
                            }, null, 8, ["checked"])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(condition.text) + " ", 1),
                            _withDirectives(_createVNode(_component_FeatherIcon, {
                              icon: "circle",
                              size: "24",
                              class: "ml-2 flex-shrink-0"
                            }, null, 512), [
                              [_vShow, !condition.isChecked]
                            ]),
                            _createTextVNode(),
                            _withDirectives(_createVNode(_component_FeatherIcon, {
                              icon: "check-circle",
                              size: "24",
                              class: "ml-2 flex-shrink-0 text-green"
                            }, null, 512), [
                              [_vShow, condition.isChecked]
                            ])
                          ], 64))
                    ], 10, _hoisted_4))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.routeCondition.head), 1),
        _createTextVNode(),
        _createVNode(_component_ConfirmRoute, {
          latitude: _ctx.latitude,
          longitude: _ctx.longitude,
          onConfirmRoute: _ctx.confirmRoute
        }, null, 8, ["latitude", "longitude", "onConfirmRoute"]),
        _createTextVNode(),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routeCondition.items, (condition, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["req-list-item", _ctx.abTest3401Class]),
              key: index,
              onClick: ($event: any) => (_ctx.onClickRouteCondition(index))
            }, [
              (_ctx.isAbTest3401TestGroup)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["req-list-item-text", { 'checked-text': condition.isChecked }])
                    }, _toDisplayString(condition.text), 3),
                    _createTextVNode(),
                    _createVNode(_component_SimpleCheckbox, {
                      checked: condition.isChecked,
                      label: "",
                      class: "req-item-indicator",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"]))
                    }, null, 8, ["checked"])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(condition.text) + " ", 1),
                    _withDirectives(_createVNode(_component_FeatherIcon, {
                      icon: "circle",
                      size: "24",
                      class: "ml-2 flex-shrink-0"
                    }, null, 512), [
                      [_vShow, !condition.isChecked]
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createVNode(_component_FeatherIcon, {
                      icon: "check-circle",
                      size: "24",
                      class: "ml-2 flex-shrink-0 text-green"
                    }, null, 512), [
                      [_vShow, condition.isChecked]
                    ])
                  ], 64))
            ], 10, _hoisted_7))
          }), 128))
        ])
      ]),
      _createTextVNode(),
      _withDirectives(_createVNode(_component_OrderFixedButton, {
        hasSub: "",
        isDisabled: "",
        abTestGroup3300: _ctx.abTestGroup3300
      }, {
        sub: _withCtx(() => [
          _createTextVNode("\n          全てチェックする必要があります\n        ")
        ]),
        default: _withCtx(() => [
          _createTextVNode("\n        次へ\n        ")
        ], undefined, true),
        _: 1
      }, 8, ["abTestGroup3300"]), [
        [_vShow, !_ctx.canNext]
      ]),
      _createTextVNode(),
      _withDirectives(_createVNode(_component_OrderFixedButton, {
        enabledVariant: "primary",
        onClick: _ctx.onClickNext,
        abTestGroup3300: _ctx.abTestGroup3300
      }, {
        default: _withCtx(() => [
          _createTextVNode("\n        次へ\n      ")
        ], undefined, true),
        _: 1
      }, 8, ["onClick", "abTestGroup3300"]), [
        [_vShow, _ctx.canNext]
      ])
    ])
  ]))
}